import Controller, { OnBeforeSubmit, OnCancel, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { AbortableSubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpResponse } from '@philips-internal/oswald-ui-core/lib/services';
import { FieldAPI, FormAPI, InputAPI } from '@philips-internal/oswald-ui-components';
import { HttpService, MessageService, } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { Inject } from '@odinjs/odin';

import BaseController from '../../BaseController';
import { Endpoint } from '../../../constants/endpoints';
import { GenerateTagDataParams } from './generate-tag-data-params';

import './generate-tag-data-controller.css';
import InformationBarUtils from '../../commons/header/information-bar-header-utils';
import { Value } from '@philips-internal/oswald-ui-core';
import ShowToast from '../../../utils/toast-service';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';

@Controller({ component: 'generate-tag-data-panel-form', fragment: 'generate-tag-data' })
class GenerateTagDataController extends BaseController {

  @Inject('generate-tag-data-form')
  generateTagDataForm!: FormAPI;

  @Inject('generate-tag-data-field')
  generateTagDataField!: FieldAPI;

  @Inject('generate-tag-data-input')
  generateTagDataInput!: InputAPI;

  @OnMount('generate-tag-data-panel-layout')
  onMountLayout(): void {
    InformationBarUtils.collapsedBar = true;

    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    this.context.set({encounterId, patientId})
  }

  redirectGeneratedSuccessfully(): void {
    GenerateTagDataParams.param = { generatedSuccessfully: 'S' };

    applicationContext.popNavigationItem();
  }

  async validateGenerateTagData(event: AbortableSubmitEvent): Promise<void> {
    const { patientId, encounterId, prescriptionId } = this.historyService.getCurrentRouteParams();

    const body = {
      encounterId: Number(encounterId),
      patientId,
      prescriptionId: Number(prescriptionId),
      seqprintId: Number(event.record.valueInput),
    } as Record<string, Value>;

    const printerDoesNotExist: HttpResponse = await HttpService.post(
      Endpoint.EXAM_COLLECT_GENERATE_TAG_DATA, {
        encounterId,
        patientId,
      }, { body }
    );

    this.generateTagDataInput.setValue('');

    if (printerDoesNotExist.body) {
      ShowToast.open(MessageService.translate(`${printerDoesNotExist.body}!`), ToastLevel.ERROR);
      return;
    }

    this.redirectGeneratedSuccessfully();
  }

  @OnBeforeSubmit({ target: 'generate-tag-data-form' })
  onChangeGenerateTagDataForm(event: AbortableSubmitEvent): void {
    this.validateGenerateTagData(event);
  }

  @OnCancel({ target: 'generate-tag-data-form' })
  onCancelGenerateTagDataForm(): void {
    applicationContext.popNavigationItem();
  }
}

export default GenerateTagDataController;
